import React from 'react'
import classNames from 'classnames'

import styles from './styles/loading.scss'

export default class Loading extends React.Component {
  render() {
    const { inline, isReady, children } = this.props

    if (!isReady) {
      return (
        <div key="loading" className={classNames(styles.spinner, inline && styles.inline)}>
          <div className={classNames(styles.spinnerItem, styles.spinner1)} />
          <div className={classNames(styles.spinnerItem, styles.spinner2)} />
          <div className={classNames(styles.spinnerItem)} />
        </div>
      )
    }

    return children
  }
}



// WEBPACK FOOTER //
// ./src/components/Loading.js